import { createSelector } from 'reselect';

const selectAggregationPolicy = (state: any) => state.aggregationPolicy;


export const selectCurrentItem = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.current);

export const selectAggregationPolicyListItems = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAggregationPolicyListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAggregationPolicyQueryItems = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.query);
export const selectAggregationPolicyCreatedItem = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.create);

export const selectAggregationPolicyUpdatedItem = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.update);

export const selectselectAggregationPolicyReadItem = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.read);

export const selectAggregationPolicyDeletedItem = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.delete);

export const selectAggregationPolicySearchedItems = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.search);

export const selectAggregationPolicyItemsCount = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.count);

export const selectAggregationPolicyItemsFilter = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.filter);
export const selectAggregationPolicyQueryByEntityItems = createSelector([selectAggregationPolicy], (aggregationPolicy) => aggregationPolicy.queryByEntityType);